/**
 * Environment Variables Validator
 * Ensures all required environment variables are set before app runs
 */

const requiredEnvVars = ["REACT_APP_BACKEND_URL"];

const optionalEnvVars = ["REACT_APP_GOOGLE_MAPS_KEY"];

/**
 * Validates that all required environment variables are set
 * @throws {Error} if required variables are missing in production
 */
export const validateEnvironment = () => {
  const missing = requiredEnvVars.filter(
    varName => !process.env[varName] || process.env[varName].trim() === ""
  );

  const missingOptional = optionalEnvVars.filter(
    varName => !process.env[varName] || process.env[varName].trim() === ""
  );

  // Log all environment info in development
  if (process.env.NODE_ENV === "development") {
    console.group("🔧 Environment Configuration");
    console.log("Environment:", process.env.NODE_ENV);
    console.log("Backend URL:", process.env.REACT_APP_BACKEND_URL || "NOT SET");
    console.log(
      "Google Maps Key:",
      process.env.REACT_APP_GOOGLE_MAPS_KEY ? "✓ Set" : "✗ NOT SET"
    );

    if (missing.length > 0) {
      console.error("❌ Missing required variables:", missing);
    } else {
      console.log("✓ All required variables set");
    }

    if (missingOptional.length > 0) {
      console.warn("⚠️ Missing optional variables:", missingOptional);
      console.warn("Some features may not work correctly");
    }

    console.groupEnd();
  }

  // In production, throw error for missing required vars
  if (process.env.NODE_ENV === "production" && missing.length > 0) {
    console.error(
      "Application misconfigured. Missing environment variables:",
      missing
    );
    throw new Error(
      "Application is not properly configured. Please contact support at support@incola.com.au"
    );
  }

  // Warn about missing optional vars
  if (missingOptional.length > 0) {
    console.warn(
      "Warning: Missing optional environment variables:",
      missingOptional,
      "\nSome features may not work as expected."
    );
  }

  return {
    isValid: missing.length === 0,
    missing,
    missingOptional
  };
};

/**
 * Get environment info for debugging
 */
export const getEnvironmentInfo = () => {
  return {
    nodeEnv: process.env.NODE_ENV,
    backendUrl: process.env.REACT_APP_BACKEND_URL,
    hasGoogleMapsKey: !!process.env.REACT_APP_GOOGLE_MAPS_KEY,
    requiredVars: requiredEnvVars,
    optionalVars: optionalEnvVars
  };
};

export default {
  validateEnvironment,
  getEnvironmentInfo
};
